import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import GridBasicItem from './basic-item';
var defaultProps = {
  className: ''
};

var Grid = function Grid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  var _styles$className = {
    styles: /*#__PURE__*/React.createElement(_JSXStyle, {
      id: "4216129763"
    }, ".jsx-4216129763{margin:0;box-sizing:border-box;padding:var(--gaid-gap-unit);}"),
    className: "jsx-4216129763"
  },
      resolveClassName = _styles$className.className,
      styles = _styles$className.styles;
  return /*#__PURE__*/React.createElement(GridBasicItem, _extends({
    className: "".concat(resolveClassName, " ").concat(className)
  }, props), children, styles);
};

Grid.defaultProps = defaultProps;
export default /*#__PURE__*/React.memo(Grid);